import { PROJECT_FILES_TAG, PROJECT_TAG, PROJECTS_LIST_TAG } from '@/api/constants';
import { api } from '@/api/core';
import { addMockProjectFiles } from './mockProjectFiles';
import { mockDelay, readMockProjectError } from './mockUtils';

/** Shape assumed until the backend contract exists */
export interface UploadProjectFilesRequest {
  projectId: string;
  files: { fileName: string; sizeBytes: number }[];
}

export interface UploadProjectFilesResponse {
  fileIds: string[];
}

const MOCK_RESPONSE_DELAY_MS = 1200;

const uploadProjectFilesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    uploadProjectFiles: builder.mutation<UploadProjectFilesResponse, UploadProjectFilesRequest>({
      // The backend project file upload endpoint does not exist yet: the files join the mock list (see mockProjectFiles.ts).
      queryFn: async (request) => {
        await mockDelay(MOCK_RESPONSE_DELAY_MS);
        const mockError = readMockProjectError();
        if (mockError) return { error: mockError };
        const added = addMockProjectFiles(request);

        return added
          ? { data: { fileIds: added.map((file) => file.fileId) } }
          : { error: { status: 404, data: 'Project not found' } };
      },
      invalidatesTags: (_result, error, { projectId }) =>
        error
          ? []
          : [
              { type: PROJECT_FILES_TAG, id: projectId },
              { type: PROJECT_TAG, id: projectId },
              { type: PROJECTS_LIST_TAG },
            ],
    }),
  }),
});

export const { useUploadProjectFilesMutation } = uploadProjectFilesApi;
